var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "video-default-location-options" }, [
    _c(
      "div",
      { staticClass: "video-default-location-form-line" },
      [
        _c(
          "div",
          { staticClass: "video-default-location-form-item-not-grow" },
          [_vm._v("页面")]
        ),
        _vm._v(" "),
        _c("PageTypeSelector", {
          staticClass: "video-default-location-form-item-grow",
          on: { change: _vm.onChangePageType },
          model: {
            value: _vm.pageType,
            callback: function ($$v) {
              _vm.pageType = $$v
            },
            expression: "pageType",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "video-default-location-vertical-space" }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "video-default-location-form-line" },
      [
        _c(
          "div",
          { staticClass: "video-default-location-form-item-not-grow" },
          [_vm._v("默认位置")]
        ),
        _vm._v(" "),
        _c("TextBox", {
          staticClass: "video-default-location-form-item-grow",
          attrs: { linear: "", "change-on-blur": "" },
          on: { change: _vm.onChangeDefaultLocation },
          model: {
            value: _vm.defaultLocation,
            callback: function ($$v) {
              _vm.defaultLocation = $$v
            },
            expression: "defaultLocation",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "video-default-location-vertical-space" }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "video-default-location-options-test" },
      [
        _c(
          "ExtendBox",
          {
            on: { change: _vm.resetObservePosition },
            model: {
              value: _vm.hiddenAdvance,
              callback: function ($$v) {
                _vm.hiddenAdvance = $$v
              },
              expression: "hiddenAdvance",
            },
          },
          [
            _c(
              "div",
              { staticClass: "video-default-location-options-advanced" },
              [
                _c("Advanced", {
                  attrs: {
                    "observe-position": _vm.observePosition,
                    "location-limit": _vm.locationLimit,
                  },
                  on: { "set-default-location": _vm.setDefaultLocation },
                }),
              ],
              1
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }